export const COURSE_LIST_VIEW_MODE = {
  viewMode: {
    advanced: 'advanced',
    simple: 'simple'
  } as const,
  defaultViewMode: 'advanced' as const
} as const;

export const CoursesListViewConsts = COURSE_LIST_VIEW_MODE;

export const DEFAULT_COURSE_LIST_VIEW_MODE = COURSE_LIST_VIEW_MODE.defaultViewMode;

export type CourseListViewMode = keyof typeof COURSE_LIST_VIEW_MODE.viewMode;
